import { IAmendmentPagedRequest } from '../../../../../../model/sge/amendment/request/amendment-paged-request';

export type PublicAmendmentSearchState = {
    parameters: IAmendmentPagedRequest;
    searchTrigger: number;
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
}

export const PublicAmendmentSearchReducer = (state: PublicAmendmentSearchState, action: any): PublicAmendmentSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
